import styled from 'styled-components'

const StyledCartSummaryRow = styled.div<{ $gutterBottom?: boolean }>`
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  line-height: 16px;
  margin-bottom: ${({ $gutterBottom }) => ($gutterBottom !== false ? '10px' : '0')};
`

export default StyledCartSummaryRow
